import Acceso from "./Enfermero/Acceso";
import Bomba from "./Enfermero/Bomba";
import Cateter from "./Enfermero/Cateter";
import ConclusionPresencial from "./Enfermero/ConclusionPresencial";
import ConclusionVirtual from "./Enfermero/ConclusionVirtual";
import ConstanciaColocacionSonda from "./Enfermero/ConstanciaColocacionSonda";
import ControlSintomas from "./Enfermero/ControlSintomas";
import CumplimientoDeIndicacion from "./Enfermero/CumplimientoDeIndicacion";
import CumplimientoDeLaIndicacion from "./Enfermero/CumplimientoDeLaIndicacion";
import FirmaPacienteFamiliar from "./Enfermero/FirmaPacienteFamiliar";
import Indicacion from "./Enfermero/Indicacion";
import InsumosYCapacitaciones from "./Enfermero/InsumosYCapacitaciones";
import InsumosYCapacitacionesAP from "./Enfermero/InsumosYCapacitacionesAP";
import ParametrosControlClinicoAE from "./Enfermero/ParametrosControlClinicoAE";
import ParametrosControlClinicoAP from "./Enfermero/ParametrosControlClinicoAP";
import ProcedimientoAP from "./Enfermero/ProcedimientoAP";
import ProcedimientoCP from "./Enfermero/ProcedimientoCP";
import ProcedimientoPresencialAE from "./Enfermero/ProcedimientoPresencialAE";
import ProcedimientoPresencialAE2 from "./Enfermero/ProcedimientoPresencialAE2";
import PsicoemocionalYEducacion from "./Enfermero/PsicoemocionalYEducacion";
import Valoracion from "./Enfermero/Valoracion";
import ValoracionAP from "./Enfermero/ValoracionAP";
import ValoracionCP from "./Enfermero/ValoracionCP";
import DatosAsistencialesGenerales from "./Generales/DatosAsistencialesGenerales";
import DatosDeVisitas from "./Generales/DatosDeVisitas";
import InfoGeneral from "./Generales/InfoGeneral";
import Profesionales from "./Generales/Profesionales";

import InformacionContratos from "./Generales/InformacionContratos";
import InformacionPaciente from "./Generales/InformacionPaciente";
import DatosClinicos from "./SegNutricion/DatosClinicos";
import EvolucionPaciente from "./SegNutricion/EvolucionPaciente";
import FinalizacionVisita from "./SegNutricion/FinalizacionVisita";
import ProgramaCEAEMedico from "./SegNutricion/ProgramaCEAEMedico";
import ProgramaCEAOCEAENutricionista from "./SegNutricion/ProgramaCEAOCEAENutricionista";
import ProgramaCEAOMedico from "./SegNutricion/ProgramaCEAOMedico";
import ProgramaDisfagia from "./SegNutricion/ProgramaDisfagia";
import ProgramaEnteral from "./SegNutricion/ProgramaEnteral";
import ProgramaHEMedico from "./SegNutricion/ProgramaHEMedico";
import ProgramaIntradialisisMedico from "./SegNutricion/ProgramaIntradialisisMedico";
import ProgramaIntradialisisNutricionista from "./SegNutricion/ProgramaIntradialisisNutricionista";
import ProgramaKetoMedico from "./SegNutricion/ProgramaKetoMedico";
import ProgramaKetoNutricionista from "./SegNutricion/ProgramaKetoNutricionista";
import ProgramaOral from "./SegNutricion/ProgramaOral";
import ProgramaParenteral from "./SegNutricion/ProgramaParenteral";

import { DatosClinicosCD } from "./SegCuidadosDomiciliarios/DatosClinicosCD";
import { InfusionDrogasCD } from "./SegCuidadosDomiciliarios/InfusionDrogasCD";
import { ManejoHeridas } from "./SegCuidadosDomiciliarios/ManejoHeridas";
import { RequerimientosAdicionales } from "./SegCuidadosDomiciliarios/RequerimientosAdicionales";

import { DatosClinicosCP } from "./SegCuidadosPaliativos/DatosClinicosCP";
import InformacionContratoCP from "./SegCuidadosPaliativos/InformacionContratoCP";
import { TratamientoCP } from "./SegCuidadosPaliativos/TratamientoCP";
import { TratamientoOpioides } from "./SegCuidadosPaliativos/TratamientoOpioides";
import ProgramaCPCDFono from "./SegFonoaudiologo/ProgramaCPCDFono";
import ProgramaDisfagiaFono from "./SegFonoaudiologo/ProgramaDisfagiaFonoAudiologia";
import DatosVisitaRehabilitacion from "./SegRehabilitacion/DatosVisitaRehabilitacion";

import EvolucionEspecialista from "./EspecialistaConsultor/EvolucionEspecialista";
import { ObservacionVisitaStep } from "./SegCuidadosDomiciliarios/ObservacionVisitaStep";
import { SituacionVisitaStep } from "./SegCuidadosDomiciliarios/SituacionVisitaStep";
import InformacionVisita from "./Generales/InformacionVisita";

export const visitaSteps = [
    //Enfermero
    {
        displayName: "Información general",
        component: (props) => <InformacionVisita variant="general" {...props} />,
        componentName: 'InfoGeneral',
        readOnly: true
    },
    {
        displayName: "Profesionales",
        component: Profesionales,
        componentName: 'Profesionales',
        readOnly: true
    },
    {
        displayName: "Datos asistenciales generales",
        component: DatosAsistencialesGenerales,
        componentName: 'DatosAsistencialesGenerales',
        readOnly: true
    },
    {
        displayName: "Indicación",
        component: Indicacion,
        componentName: 'Indicacion',
        readOnly: true
    },
    {
        displayName: "Datos de visita",
        component: DatosDeVisitas,
        componentName: 'DatosDeVisitas',
    },
    {
        displayName: "Cateter",
        component: Cateter,
        componentName: 'Cateter',
    },
    {
        displayName: "Bomba",
        component: Bomba,
        componentName: 'Bomba',
    },
    {
        displayName: "Acceso",
        component: Acceso,
        componentName: 'Acceso',
    },
    {
        displayName: "Cumplimiento de la indicación",
        component: CumplimientoDeLaIndicacion,
        componentName: 'CumplimientoDeLaIndicacion',
    },
    {
        displayName: "Cumplimiento de la indicación",
        component: CumplimientoDeIndicacion,
        componentName: 'CumplimientoDeIndicacion',
    },
    {
        displayName: "Parametros de control clínico",
        component: ParametrosControlClinicoAE,
        componentName: 'ParametrosControlClinicoAE',
    },
    {
        displayName: "Parametros de control clínico",
        component: ParametrosControlClinicoAP,
        componentName: 'ParametrosControlClinicoAP',
    },
    {
        displayName: "Insumos y capacitaciones",
        component: InsumosYCapacitaciones,
        componentName: 'InsumosYCapacitaciones',
    },
    {
        displayName: "Insumos y capacitaciones",
        component: InsumosYCapacitacionesAP,
        componentName: 'InsumosYCapacitacionesAP',
    },
    {
        displayName: "Control de síntomas",
        component: ControlSintomas,
        componentName: 'ControlSintomas',
    },
    {
        displayName: "Psicoemocional y educación",
        component: PsicoemocionalYEducacion,
        componentName: 'PsicoemocionalYEducacion',
    },
    {
        displayName: "Valoración",
        component: Valoracion,
        componentName: 'Valoracion',
    },
    {
        displayName: "Valoración",
        component: ValoracionAP,
        componentName: 'ValoracionAP',
    },
    {
        displayName: "Valoración",
        component: ValoracionCP,
        componentName: 'ValoracionCP',
    },
    {
        displayName: "Procedimiento",
        component: ProcedimientoPresencialAE,
        componentName: 'ProcedimientoPresencialAE',
    },
    {
        displayName: "Procedimiento",
        component: ProcedimientoPresencialAE2,
        componentName: 'ProcedimientoPresencialAE2',
    },
    {
        displayName: "Procedimiento",
        component: ProcedimientoAP,
        componentName: 'ProcedimientoAP',
    },
    {
        displayName: "Procedimiento",
        component: ProcedimientoCP,
        componentName: 'ProcedimientoCP',
    },
    {
        displayName: "Constancia de colocación de sonda/ Control de PH",
        component: ConstanciaColocacionSonda,
        componentName: 'ConstanciaColocacionSonda',
    },
    {
        displayName: "Conclusión",
        component: ConclusionPresencial,
        componentName: 'ConclusionPresencial',
    },
    {
        displayName: "Conclusión",
        component: ConclusionVirtual,
        componentName: 'ConclusionVirtual',
    },
    {
        displayName: "Firma paciente/familiar",
        component: FirmaPacienteFamiliar,
        componentName: 'FirmaPacienteFamiliar',
    },
    //Seguimiento nutrición
    {
        displayName: "Información paciente",
        component: InformacionPaciente,
        componentName: 'InformacionPaciente',
    },
    {
        displayName: "Información contratos",
        component: (props) => <InformacionVisita variant="contratos" {...props} />,
        componentName: 'InformacionContratos',
        readOnly: true,
    },
    {
        displayName: "Datos clínicos",
        component: DatosClinicos,
        componentName: 'DatosClinicos',
    },
    {
        displayName: "Enteral",
        component: ProgramaEnteral,
        componentName: 'ProgramaEnteral',
    },
    {
        displayName: "Parenteral",
        component: ProgramaParenteral,
        componentName: 'ProgramaParenteral',
    },
    {
        displayName: "NPID - Médico",
        component: ProgramaIntradialisisMedico,
        componentName: 'ProgramaIntradialisisMedico',
    },
    {
        displayName: "NPID - Nutricionista",
        component: ProgramaIntradialisisNutricionista,
        componentName: 'ProgramaIntradialisisNutricionista',
    },
    {
        displayName: "Oral",
        component: ProgramaOral,
        componentName: 'ProgramaOral',
    },
    {
        displayName: "KETO - Médico",
        component: ProgramaKetoMedico,
        componentName: 'ProgramaKetoMedico',
    },
    {
        displayName: "KETO - Nutricionista",
        component: ProgramaKetoNutricionista,
        componentName: 'ProgramaKetoNutricionista',
    },
    {
        displayName: "HE - Cuidado de catéter",
        component: ProgramaHEMedico,
        componentName: 'ProgramaHEMedico',
    },
    {
        displayName: "CEAO - Médico",
        component: ProgramaCEAOMedico,
        componentName: 'ProgramaCEAOMedico',
    },
    {
        displayName: "CEAO - CEAE - Nutricionista",
        component: ProgramaCEAOCEAENutricionista,
        componentName: 'ProgramaCEAOCEAENutricionista',
    },
    {
        displayName: "CEAE Medico",
        component: ProgramaCEAEMedico,
        componentName: 'ProgramaCEAEMedico',
    },
    {
        displayName: "Disfagia",
        component: ProgramaDisfagia,
        componentName: 'ProgramaDisfagia',
    },
    {
        displayName: "Evolución paciente",
        component: EvolucionPaciente,
        componentName: 'EvolucionPaciente',
    },
    {
        displayName: "Finalización de la visita",
        component: FinalizacionVisita,
        componentName: 'FinalizacionVisita',
    },
    //Seg Cuidados Domiciliarios
    {
        displayName: "Datos clínicos",
        component: DatosClinicosCD,
        componentName: 'DatosClinicosCD',
    },
    {
        displayName: "Infusion de Drogas",
        component: InfusionDrogasCD,
        componentName: 'InfusionDrogasCD',
    },
    {
        displayName: "Manejo de Heridas",
        component: ManejoHeridas,
        componentName: 'ManejoHeridas',
    },
    {
        displayName: "Tratamiento",
        component: (props) => <ObservacionVisitaStep variant="Tratamiento" {...props} />,
        componentName: 'Tratamiento',
    },
    {
        displayName: "Situación Actual",
        component: (props) => <SituacionVisitaStep variant="SituacionActual" {...props} />,
        componentName: 'SituacionActual',
    },
    {
        displayName: "Situación Actual",
        component: (props) => <SituacionVisitaStep variant="SituacionActualCP" {...props} />,
        componentName: 'SituacionActualCP',
    },
    {
        displayName: "Requerimiento Actual",
        component: (props) => <ObservacionVisitaStep variant="RequerimientoActual" {...props} />,
        componentName: 'RequerimientoActual',
    },
    {
        displayName: "Requerimiento Actual",
        component: (props) => <ObservacionVisitaStep variant="RequerimientoActualCP" {...props} />,
        componentName: 'RequerimientoActualCP',
    },
    {
        displayName: "Requerimientos Adicionales",
        component: RequerimientosAdicionales,
        componentName: 'RequerimientosAdicionales',
    },
    //Seg Cuidados Paliativos
    {
        displayName: "Información contrato",
        component: InformacionContratoCP,
        componentName: 'InformacionContratoCP',
    },
    {
        displayName: "Datos clínicos",
        component: DatosClinicosCP,
        componentName: 'DatosClinicosCP',
    },
    {
        displayName: "Situación Socio Familiar",
        component: (props) => <SituacionVisitaStep variant="SituacionSocioFamiliar" {...props} />,
        componentName: 'SituacionSocioFamiliar',
    },
    {
        displayName: "Tratamiento",
        component: TratamientoCP,
        componentName: 'TratamientoCP',
    },
    {
        displayName: "Tratamiento Opioides",
        component: TratamientoOpioides,
        componentName: 'TratamientoOpioides',
    },
    {
        displayName: "Disfagia (Fonoaudiologo)",
        component: ProgramaDisfagiaFono,
        componentName: 'ProgramaDisfagiaFono',
    },
    {
        displayName: "CP - CD (Fonoaudiologo)",
        component: ProgramaCPCDFono,
        componentName: 'ProgramaCPCDFono',
    },
    {
        displayName: "Datos de Visitas",
        component: DatosVisitaRehabilitacion,
        componentName: 'DatosVisitaRehabilitacion',
    },
    //Especialista-Consultar
    {
        displayName: "Evolución de paciente",
        component: EvolucionEspecialista,
        componentName: 'EvolucionEspecialista'
    }
];